import { ValidatedInput } from '@finbeat/react-toolkit';
import { BOValidatedDatePicker } from 'base-components/BOValidatedDatePicker/BOValidatedDatePicker';
import OrderInfoModal from 'components/Workplaces/Clients/OrderInfoModal';
import { PaymentToClientInfo } from 'models/api/paymentsToClients';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';

const OrderTab = () => {
    const { t } = useTranslation();
    const [orderOpen, setOrderOpen] = useState(false);
    const { watch } = useFormContext<PaymentToClientInfo>();

    const orderId = watch('orderId');
    return (
        <>
            <Container>
                <Row>
                    <Col>
                        <BOValidatedDatePicker<PaymentToClientInfo>
                            name="orderDt"
                            inputProps={{
                                label: t('BackOfficeStartDate'),
                            }}
                            disabled
                        />
                    </Col>
                    <Col>
                        <ValidatedInput<PaymentToClientInfo>
                            name="term"
                            label={t('BackOfficeTerm')}
                            disabled
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ValidatedInput<PaymentToClientInfo>
                            type="number"
                            name="loanAmount"
                            label={t('BackOfficeLoanAmount')}
                            disabled
                        />
                    </Col>
                    <Col>
                        <ValidatedInput<PaymentToClientInfo>
                            type="number"
                            name="totalToPay"
                            label={t('BackOfficeDebtAmount')}
                            disabled
                        />
                    </Col>
                </Row>
            </Container>
            {orderOpen && (
                <OrderInfoModal
                    id={orderId}
                    toggle={() => setOrderOpen(false)}
                    isOpen={orderOpen}
                />
            )}
        </>
    );
};

export default OrderTab;
